module.exports = __webpack_public_path__ + "img/flag-green.d90d0c60.svg";